import styles from './modal.module.scss';
import { motion } from 'framer-motion';
import React, { useCallback, useEffect, useRef } from 'react';

const Modal = ({ children, close, width, minHeight, showCloseButton = true }) => {
  const ref = useRef(null);
  const escapeListener = useCallback(e => {
    if (e.key === 'Escape') {
      close();
    }
  }, []);

  const clickListener = useCallback(e => {
    if (!ref.current.contains(e.target)) {
      close();
    }
  });

  useEffect(() => {
    // Mounted
    document.body.style.overflow = 'hidden';

    document.addEventListener('mousedown', clickListener);
    document.addEventListener('keyup', escapeListener);

    // Will unmount
    return () => {
      document.body.style.overflow = null;
      document.removeEventListener('mousedown', clickListener);
      document.removeEventListener('keyup', escapeListener);
    };
  }, []);

  const style = {};

  if (width) {
    style.width = width;
  }

  if (minHeight) {
    style.minHeight = minHeight;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.1 } }}
      exit={{ opacity: 0, transition: { duration: 0.1 } }}
      className={styles.wrapper}
    >
      <motion.div
        className={styles.body}
        ref={ref}
        initial={{ opacity: 0, y: '8px' }}
        animate={{ opacity: 1, y: '0' }}
        exit={{ opacity: 0, y: '8px' }}
        transition={{
          duration: 0.2,
          delay: 0.2,
        }}
        style={style}
      >
        {showCloseButton && (
          <button onClick={close} className={styles.close}>
            &times;
          </button>
        )}
        {children}
      </motion.div>
    </motion.div>
  );
};

export default Modal;
